import React from "react";
import styled from "styled-components";
// Components
import PricingTable from "../Elements/PricingTable";

export default function Pricing() {
  return (
    <Wrapper id="pricing">
      <div className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold" style={{paddingTop: "50px"}}>Pricing</h1>
          </HeaderInfo>
          <TablesWrapper className="flexSpaceNull">
            <TableBox>
              <PricingTable
                icon="poster"
                price="£5.00"
                title="File Download"
                text="Full sized png download file of your poster"
                offers={[
                  { name: "Full Size", cheked: true },
                  { name: "No Watermark", cheked: true },
                  { name: "Immediate Download", cheked: true },
                ]}
              />
            </TableBox>
          </TablesWrapper>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding: 0px 0;
`;
const HeaderInfo = styled.div`
  margin-bottom: 0px;
  text-align: center;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const TablesWrapper = styled.div`
  align-items: center;
  justify-content: center;
  padding-bottom: 50px;
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const TableBox = styled.div`
  width: 31%;
  @media (max-width: 860px) {
    width: 100%;
    max-width: 370px;
    margin: 0 auto
  }
`;




